import { render, staticRenderFns } from "./AudienceCardSavedQueryDetails.vue?vue&type=template&id=670134e1"
import script from "./AudienceCardSavedQueryDetails.vue?vue&type=script&lang=js"
export * from "./AudienceCardSavedQueryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports